<svg (mouseenter)="mouseEnter()"
     (mouseleave)="mouseLeave()"
     [attr.height]="height"
     [attr.width]="width"
     [class.cursor-pointer]="isButton"
     fill="none"
     viewBox="0 0 24 24"
     xmlns="http://www.w3.org/2000/svg">

  <circle [attr.fill]="color" cx="12" cy="12" r="12"/>
  <path [attr.stroke]="plusColor" d="M12 7V17M17 12L7 12" stroke-width="2"/>
</svg>
